/* Flashback native VAT display sync for Empire classic PDP. */
(function () {
  'use strict';

  function updateProductPricing(pricing) {
    if (!pricing) return;

    var exVat = pricing.querySelector('[data-flashback-ex-vat]');
    var unitExVat = pricing.querySelector('[data-flashback-unit-ex-vat]');
    var map = pricing.querySelector('[data-flashback-vat-variant-map]');
    if (!exVat || !map) return;

    var scope = pricing.closest('[data-product-details]') || pricing.closest('[data-product-container]') || pricing.closest('section') || document;
    var variantSelect = scope.querySelector('[data-variants]') || scope.querySelector('select[name="id"]') || scope.querySelector('input[name="id"]');
    if (!variantSelect || !variantSelect.value) return;

    var variantPrice = map.querySelector('[data-flashback-variant-id="' + variantSelect.value + '"]');
    if (!variantPrice) return;

    var formatted = variantPrice.getAttribute('data-flashback-ex-vat-formatted');
    if (formatted) exVat.textContent = formatted;

    if (unitExVat) {
      var unitFormatted = variantPrice.getAttribute('data-flashback-unit-ex-vat-formatted');
      if (unitFormatted) unitExVat.textContent = unitFormatted;
    }
  }

  function bindProductPricing(pricing) {
    if (!pricing || pricing.dataset.flashbackVatBound === 'true') return;
    pricing.dataset.flashbackVatBound = 'true';

    updateProductPricing(pricing);

    var priceContainer = pricing.querySelector('[data-price-container]');
    if (priceContainer && window.MutationObserver) {
      new MutationObserver(function () {
        updateProductPricing(pricing);
      }).observe(priceContainer, { childList: true, characterData: true, subtree: true });
    }

    pricing.addEventListener('change', function () {
      window.setTimeout(function () { updateProductPricing(pricing); }, 0);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-product-pricing]').forEach(bindProductPricing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-product-pricing]')) bindProductPricing(node);
          if (node.querySelectorAll) init(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
